import { FC } from "react";

import Box from "@mui/material/Box";
import { TicketingFormCategory } from "@simplyk/common";

import { usesEntryTerminology } from "@/common/helpers/sweepstakes";
import { useTranslate } from "@/common/hooks/useTranslate";
import { FormTypography } from "@/forms-design-system/FormTypography";

interface RatesTitleProps {
  formCategory: TicketingFormCategory;
}

export const RatesTitle: FC<RatesTitleProps> = ({ formCategory }) => {
  const { t } = useTranslate();

  return (
    <Box sx={{ paddingTop: 1 }}>
      <FormTypography variant="h5" vibe="intense" component="h2">
        {t("ticketing", usesEntryTerminology(formCategory) ? "prizes.entriesTitle" : "prizes.ticketsTitle")}
      </FormTypography>
    </Box>
  );
};
